import React from "react";
import { Link, useLocation } from "react-router-dom";
import { NAV_CTA } from "../../data/nav";
import { segmentoPorPath } from "../../data/segmentos";
import { entregaPorPath } from "../../data/entregas";
import { entregaDeAutorizacion } from "../../data/autorizacion";
import { trabajoPorPath } from "../../data/trabajos";

const MobileActionBar = () => {
  const { pathname } = useLocation();

  /*
    Solo puede haber una barra fija a la vez. En las páginas de segmento la
    ocupa FotoStickyCta, que además muestra el precio; en /precios y /contacto
    el CTA ya es el contenido de la página.

    La condición pregunta a los datos si la ruta es un segmento, en vez de
    mirar cómo empieza el path: `startsWith("/fotografia")` también taparía la
    barra en cualquier ruta futura que empezara igual — /fotografia-tips, por
    ejemplo — sin que nada avisara.
  */
  if (pathname === "/contacto" || pathname === "/precios" || segmentoPorPath(pathname)) {
    return null;
  }

  /* En una entrega privada el visitante ya es cliente: "Ver precios" fijo
     sobre su galería estorba y compite con el botón de descarga. */
  if (entregaPorPath(pathname) || entregaDeAutorizacion(pathname)) return null;

  /* Un trabajo del portafolio no es página de precio: su CTA es "quiero algo
     así" y ya está en la página. */
  if (trabajoPorPath(pathname)) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-navy-100 bg-sand-50/95 px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] backdrop-blur-xl lg:hidden">
      <Link to={NAV_CTA.to} className="btn-omega w-full">
        {NAV_CTA.label}
      </Link>
    </div>
  );
};

export default MobileActionBar;
